exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".codeInput{margin:20px auto}.body{background:#fff;padding:8px}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/ResetPassword.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB,AACD,MACE,gBAAkB,AAClB,WAAa,CACd","file":"ResetPassword.vue","sourcesContent":["\n.codeInput {\n  margin: 20px auto;\n}\n.body {\n  background: white;\n  padding: 8px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d06bd910","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ResetPassword.vue
// module id = 738
// module chunks = 18